import React from 'react';
import SEO from '../components/seo';
// import ProjectSliderMonto from '../components/projects/projectSliderMonto';
// import ProjectSliderLemosta from '../components/projects/projectSliderLemosta';
import ProjectSliderTampack from '../components/projects/projectSliderTampack';
// import { HashLink } from 'react-router-hash-link';
// import $ from 'jquery';

const ProjectPageTampack = () => {
  return (
    <>
      <SEO title="TAMPACK | Our Projects" />
      <section className="projectVisual">
        <h1 className="visual--title">
          <span>Our</span> Projects
        </h1>
        <p className="visual--desc">
          全人類の健康をアップデートさせるべく
          <br />
          サイレンサーが展開するプロジェクト。
        </p>
      </section>
      <section className="projectWrap">
        <div className="projectBox" id="p6">
          <h2 className="projectName">TAMPACK</h2>
          {/* <p className="projectCopy">戦う準備をしている人のために</p> */}
          <div className="projectSlider--wrap">
            <ProjectSliderTampack />
          </div>
          {/* <h3 className="projectOverview">完全予約制の広島のオアシス</h3>
          <h3 className="projectOverview">施術前カウンセリングシートとディスカッションで身体の声を聴く</h3>
          <h3 className="projectOverview">施術後にお送りするオーダーメイドレポート</h3> */}
          <h3 className="projectOverview">戦う準備をしている人のために</h3>
          <div className="projectText">
            <p>
              生産合理性、経済合理性。
              そんな言葉と引き換えに著しく低下したモノがある。
              それは食物が本来持っていたはずの栄養素。
            </p>
            <p>
              現代人はそれらを当たり前に口する生活の中で無自覚に真に必要な栄養さえも摂取出来なくなっている。
            </p>
            <p>
              そこで"全人類をゴキゲンへと導く"とミッションを掲げるサイレンサーが現代へ提示するあたらしい解答は「プロテイン」
            </p>
            <p>
              プロテイン。
              直訳すると「タンパク質」、古代ギリシャ語では「一番重要な物」と訳される。
            </p>
            <p>
              タンパク質不足+糖質過多＋脂肪酸不足＋ビタミン不足＋ミネラル不足で生まれた、サイレンサーが現代の社会問題として声を大にして警笛を鳴らし続けている「質的栄養失調」。
              このままの食文化では筋肉のみならず、脳、髪、爪、皮膚、血液、臓器に対する最適な栄養的回答は永遠に得られない。
              そこを日々の中で無理なく不足し栄養素を補っていけるのがこのプロテイン、通称TAMPACK(タンパック)。
            </p>
            <p>
              開発にあたり「普段、口にするそのモノの生産背景」まで深くリサーチする"トレーサビリティ概念"をベースに"ホンモノ"の材料に徹底的に拘り、３年の歳月を掛けてようやく完成。
            </p>
            <p>
              健康と気分。 もうこの２つは"人のせい"には出来ない。
              自らの手で心身を"ゴキゲンの領域"へ。 さぁ！TAMPACKを片手に「VS
              質的栄養失調」の闘いの幕を上げよう！
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a href="https://tampack.jp/" target="_blank" rel="noreferrer">
                Online Shop
              </a>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default ProjectPageTampack;
